import React from "react";
import TabBar, { TabBarProps } from "../../../../shared/components/TabBar";
import TopProductOrdersTable from "../Content/TopProductOrdersTable";
import { RevenueTab } from "./RevenueTab";
import { CategoryTab } from "./CategoryTab";

interface TabNavigationProps {}

const DashboardTabNavigation = ({}: TabNavigationProps) => {
    const tabs: TabBarProps[] = [
        {
            label: "Doanh Thu",
            labelEN: "revenue",
            content: <RevenueTab />,
        },
        {
            label: "Danh Mục",
            labelEN: "overview",
            content: <CategoryTab />,
        },
    ];

    return <TabBar tabs={tabs} />;
};

export default DashboardTabNavigation;
